import api from ".";
import { getToken } from "../Auth/Token";

export const createDistributor = async (room, date, headers, workOrders) => {
  try {
    const token = getToken();

    const payload = {
      room,
      date,
      headers,
      workOrders,
    };

    const res = await api.post("/api/workOrder/createDistributor", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (error) {
    console.error("Create Distributor API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const getDistributorList = async (startDate, endDate, roomFilter = null) => {
  try {
    const token = getToken();

    const params = { startDate, endDate };
    if (roomFilter) params.room = roomFilter; 

    const res = await api.get("/api/workOrder/getDistributor", {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res.data; 
  } catch (error) {
    console.error("Get Distributor List API Error:", error.response?.data || error);
    throw error;
  }
};

export const batchUpdatePacking = async (room, date, updates) => {
  try {
    const token = getToken();

    if (!Array.isArray(updates) || updates.length === 0) {
      throw new Error("Updates must be a non-empty array");
    }

    const payload = { room, date, updates };

    const res = await api.post("/api/workOrder/batchpacking", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (error) {
    console.error("Batch Update Packing API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};
